// Cookie consent banner.
export default {
  en: {
    label: 'Cookie consent',
    message:
      "We use essential cookies to make the site work. With your consent, we'd also use analytics to improve it.",
    customize: 'Customize',
    essentialOnly: 'Essential only',
    acceptAll: 'Accept all',
  },
  cs: {
    label: 'Souhlas s cookies',
    message:
      'Používáme nezbytné cookies, aby web fungoval. S vaším souhlasem bychom také použili analytiku k jeho vylepšení.',
    customize: 'Přizpůsobit',
    essentialOnly: 'Pouze nezbytné',
    acceptAll: 'Přijmout vše',
  },
};
